module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"help":"Co jsou Projekty?","noSubmission":"(žádné)"},"de":{"help":"Was sind Projekte?","noSubmission":"(keine)"},"es":{"help":"¿Qué son los Proyectos?","noSubmission":"(ninguno)"},"fr":{"help":"Que sont les \\"Projets\\" ?","noSubmission":"(aucune)"}}')
  delete Component.options._Ctor
}
